import { useNavigate } from '@tanstack/react-router';
import { memo, useCallback } from 'react';

import ConfigureModelCTAIcon from '@/assets/configure-model-cta-icon.svg?react';
import { Button, Flex, Heading, Text } from '@/components/core';
import { ArrowIcon } from '@/components/icons';

type ConfigureModelCTAProps = {
  agentId?: string | null;
};

const IConfigureModelCTA = ({ agentId }: ConfigureModelCTAProps) => {
  const navigate = useNavigate();

  const onGoToSetup = useCallback(() => {
    if (agentId) {
      navigate({
        to: '/agents/$agentId/integration',
        params: { agentId },
      });
    }
  }, [agentId, navigate]);

  return (
    <Flex className="h-[80%] w-[90%] items-center justify-center">
      <Flex col variant="secondary" className="p-lg gap-md w-[25rem] items-center rounded-xl text-center">
        <ConfigureModelCTAIcon />

        <Heading size="lg">Setup your AI model</Heading>

        <Text>You need to configure your AI model before you can start processing your documents.</Text>

        <Flex variant="plain" className="justify-center">
          <Button variant="primary" onPress={onGoToSetup}>
            <Text size="md">Go to setup</Text>
            <ArrowIcon rotation="right" />
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export const ConfigureModelCTA = memo(IConfigureModelCTA) as typeof IConfigureModelCTA;
